import React, { useEffect, useRef, useState } from "react";
import {
    Card,
  Input,
  Form,
  Select,
  Button,  
} from "antd";
import api from "utils/api";
import "./MedicalTest.scss";
import SubmitButton from '../../Patient/SubmitButton'
import debounce from "lodash.debounce";
import { CONSTANTS } from "utils/constant";
import Validators from "Common/Validators";
              function MedicalTestform(props) {
                const med_test_form = useRef(null);
                
                const med_search = useRef(null);

                const [ search_suggestions , setSearchSuggestion ] = useState([])

                const [ test_name , setTestName ] = useState("")
                
              
                const [ disable_name, setDisableName] =useState(false)

                const [ other , setOther] = useState("")

                const [ test_id , setTestID ] = useState("")
            

                useEffect(()=>{
               if(props.edit_array){
                  let edit_data=props.edit_array
                  setTestID(props.edit_array?.test_id?.split("_")?.[0])
                  if(props.edit_array?.test_id?.split("_")?.[0] == "9"){
                    setDisableName(true)
                  }
                  edit_data["test_id"]=props.edit_array?.test_id?.split("_")?.[1]              
                  med_test_form?.current?.setFieldsValue(edit_data)
               }
                },[props.edit_array])

                const SaveForm = (vals,action) => {
                  if(props.is_edit==true){                
                    vals.test_id=test_id+"_"+vals.test_id
                    vals.instructions=vals?.instructions?.trim()?.length>0?vals.instructions.trim():null
                    props.update_test(vals,action)
                  }else{
                    if(disable_name){
                    vals.test_id=med_search?.current?.getFieldValue("test-search")?.split("_")?.[0]+"_"+other
                    }else{
                    vals.test_id=med_search?.current?.getFieldValue("test-search")
                    }
                    if(action !="cancel"){
                    props.add_test(vals)
                    typeof props.formAction == "function" && props.formAction(true)
                    }
                  }
                  if(test_name || disable_name){
                  med_test_form?.current?.resetFields();
                  med_search?.current?.resetFields();
                  setDisableName(false)
                  setTestName("")
                  setSearchSuggestion([])
                  }
                
                }
                
                const handleOnSearch = (data) => {
                
                  setTestName(data)
                  med_test_form?.current?.setFieldsValue({test_id:data})
                  if(data.trim().length>0){
                    debouncedFunction(data)
                    }
                  
                };

                const  debouncedFunction = debounce((data) => {
                  api
                  .get_test_suggestion(data.trim())
                  .then((res) => {  
                    if(res.status==200){
                   let sortedData = res?.data?.data?.results.sort(
                      (objA, objB) => Number(objA.sort_id) - Number(objB.sort_id),
                  );
                    setSearchSuggestion(sortedData)
                   }else{

                   }
                  })
                  .catch((err) => {
                    console.log(err);
                  })
                  .finally(() => {
                    // this.setState({ isLoading: false, isinnerLoading: false });
                  });
                }, 800);
                
                const onChange=(opt,val)=>{
                  med_test_form?.current?.resetFields(); 
                  if(opt?.split("_")?.[0]== "9"){
                    setDisableName(true)
                    
                  }else{
                    setDisableName(false)
                    setTestName(opt?.split("_")?.[1])
                    med_test_form?.current?.setFieldsValue({test_id:opt?.split("_")?.[1]})
                  }
                 

                    
                    
                }
              
                return (

                  <div className="medical-test-form">
                      <div className="search-block">
                        <Form 
                        ref={med_search}
                        >
                        <Form.Item   
                          name="test-search"
                          label=""
                          >
                              <Select
                                      disabled={props.is_edit || props?.is_prescription_report}
                                      placement="bottomLeft"
                                      showSearch
                                      filterOption={false}
                                      getPopupContainer={(trigger) => trigger.parentNode}
                                      aria-autocomplete="false"     
                                      allowClear
                                      onClear={()=> {setTestName(""),setSearchSuggestion([]),setDisableName(false)}}
                                      autoClearSearchValue={true}
                                        // onSelect={(val)=>{setTestName(val),}}
                                       onSelect={(option,value)=>{onChange(option,value)}}
                                      // options={search_suggestions}
                                      style={{
                                        width: "100%",
                                        paddingLeft: "0px !important",
                                      }}
                        
                                      placeholder={"Search Test"}
                                      popupClassName="bottom-positioned-dropdown"
                                      onSearch={(e,i) => {
                                        handleOnSearch(e, i);
                                        
                                      }}
                                    >
                                    
                                    
                                              {search_suggestions &&
                                                search_suggestions.map((o, i) => {
                                                  return (
                                                    <Select.Option
                                                      value={`${o.field_id}_${o.field_name}`}
                                                      key={i}
                                                      label={o.field_name}
                                                    >
                                                      {o.field_name}
                                                    </Select.Option>
                                                  );
                                                })}
                                    </Select>
                                    </Form.Item>
                                   
                                    </Form>
                              
              </div>
             
                    {test_name?.length>0 || props?.is_edit || disable_name? 
                          <Form
                          ref={med_test_form}
                          colon={false}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 12 }}
                          labelAlign={"left"}
                          onFinish={(val)=> SaveForm(val)}
                          >
                        
                            <div className="test-info-block">
                              <Form.Item
                              name="test_id"
                              label={CONSTANTS.TEST_NAME}
                              rules={[
                                { required: disable_name,
                                  message: `${CONSTANTS.MED_TEST_NAME_ERR_MESSAGE}`
                                 },
                                 Validators.validateIsTestName
                             
                              ]}
                            
                              >
                                  <Input  
                                  maxLength={100}
                                   onChange={(e)=>setOther(e.target.value?.trim())}       
                                   value={test_name}  
                                   disabled ={!disable_name}
                                   placeholder={"Test Name"}/>
                              </Form.Item>
                            
                              <Form.Item
                                name="instructions"
                                label={CONSTANTS.CLINICAL_INSTRUCTION}
                                rules={[  
                                  {
                                    max: 250,
                                    message: "This field exceeds maximum number of 250 characters.",
                                  }
                                ]}
                                
                                
                              >
                                  <Input.TextArea  placeholder="Clinical Instruction"/>
                              </Form.Item>
                        
                              </div>
                      <div  className="submit-button-wrapper">
                          <Button  className="confirm-btn" htmlType="submit" >{props?.is_edit?"Update":"Add" }</Button>
                        <Button  className="cancel-btn" onClick={()=>SaveForm(props.edit_array,"cancel")}>Cancel</Button>  
                          </div>
                          </Form>
                        :""}
                          
                      
                  </div>
                );
              }

export default MedicalTestform;
